import React from 'react'
import { Link } from 'react-router-dom'
const Pricing = () => {
    return (
        <>
            <div className="container py-5">
                <div className="row justify-content-center g-4">
                    <div className="col-12">
                        <div className="content mb-5">
                            <h2 className="fw-bold">Tarification </h2>
                            <p className='text-center'>
                                Quelle que soit l'offre, profitez pleinement de votre application et démarquez-vous de la concurrence.
                            </p>
                        </div>
                    </div>
                    <div className="col-md-3">
                        <div className="pricing-card card h-100 p-4">
                            <div className="card-body text-center">
                                <h5 className="text-muted text-uppercase mb-3">Starter</h5>
                                <h2 className="display-4 fw-bold mb-4">6500 <br /> <span className='exposant'>FCFA/01 MOIS</span> </h2>
                                <p className="text-muted mb-4">Gérez votre pressing simplement</p>
                                <ul className="list-unstyled feature-list mb-4">
                                    <li>Livraison en 03 jours</li>
                                    <li className='fw-bold'>01 Compte</li>
                                    <li>Commandes Illimitées</li>
                                    <li>Statistiques</li>
                                    <li>Code promo</li>
                                    <li>Personnalisation des messages</li>
                                    <li>Services supports</li>
                                </ul>
                                <Link to={"https://paiement.pressing360.com/checkout/?clear_cart=1&add-to-cart=4497"} className="btn  btn-custom text-white w-100">
                                    Commander
                                    <i className="fas fa-arrow-right m-2"></i>
                                </Link>
                            </div>
                        </div>
                    </div>

                    <div className="col-md-3">
                        <div className="pricing-card card h-100 p-4 border-2 border-primary">

                            <div className="card-body text-center">
                                <h5 className="text-muted text-uppercase mb-3">Pro</h5>
                                <h2 className="display-4 fw-bold mb-4">36.000 <br /> <span className='exposant'>FCFA/06 MOIS</span></h2>
                                <p className="text-muted mb-4">Optimisez vos opérations quotidiennes</p>
                                <ul className="list-unstyled feature-list mb-4">
                                    <li>Livraison en 03 jours</li>
                                    <li className='fw-bold'>03 Comptes</li>
                                    <li>Commandes Illimitées</li>
                                    <li>Statistiques</li>
                                    <li>Code promo</li>
                                    <li>Personnalisation des messages</li>
                                    <li>Services supports</li>
                                </ul>

                                <Link to={"https://paiement.pressing360.com/checkout/?clear_cart=1&add-to-cart=4501"} className="btn  btn-custom text-white w-100">
                                    Commander
                                    <i className="fas fa-arrow-right m-2"></i>
                                </Link>
                            </div>
                        </div>
                    </div>

                    <div className="col-md-3">
                        <div className="pricing-card card h-100 p-4">
                            <span className="badge bg-danger popular-badge">Populaire</span>
                            <div className="card-body text-center">
                                <h5 className=" text-danger text-uppercase mb-3">premium</h5>
                                <h2 className="display-4 fw-bold mb-4">66.000 <br /> <span className='exposant'>FCFA/12 MOIS</span></h2>
                                <p className="text-muted mb-4">Contrôlez votre pressing de A à Z</p>
                                <ul className="list-unstyled feature-list mb-4">
                                    <li>Livraison en 03 jours</li>
                                    <li className='fw-bold'>05 Comptes</li>
                                    <li>Commandes Illimitées</li>
                                    <li>Statistiques</li>
                                    <li>Code promo</li>
                                    <li>Personnalisation des messages</li>
                                    <li>Services supports</li>
                                </ul>
                                <Link to={"https://paiement.pressing360.com/checkout/?clear_cart=1&add-to-cart=4503"} className="btn  btn-custom text-white w-100">
                                    Commander
                                    <i className="fas fa-arrow-right m-2"></i>
                                </Link>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-3">
                        <div className="pricing-card card h-100 p-4">
                            <div className="card-body text-center">
                                <h5 className="text-muted text-uppercase mb-3">Elite</h5>
                                <h2 className="display-4 fw-bold mb-4">120.000 <br /> <span className='exposant'> FCFA/24 MOIS</span></h2>
                                <p className="text-muted mb-4">L’excellence pour les pressings haut de gamme</p>
                                <ul className="list-unstyled feature-list mb-4">
                                    <li>Livraison en 03 jours</li>
                                    <li className='fw-bold'>12 Comptes</li>
                                    <li>Commandes Illimitées</li>
                                    <li>Statistiques</li>
                                    <li>Code promo</li>
                                    <li>Personnalisation des messages</li>
                                    <li>Services supports</li>
                                </ul>
                                <Link to={"https://paiement.pressing360.com/checkout/?clear_cart=1&add-to-cart=4505"} className="btn  btn-custom text-white w-100">
                                    Commander
                                    <i className="fas fa-arrow-right m-2"></i>
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Pricing